import { render, staticRenderFns } from "./queryPageList.vue?vue&type=template&id=15875739&scoped=true&"
import script from "./queryPageList.vue?vue&type=script&lang=js&"
export * from "./queryPageList.vue?vue&type=script&lang=js&"
import style0 from "./queryPageList.vue?vue&type=style&index=0&id=15875739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15875739",
  null
  
)

component.options.__file = "queryPageList.vue"
export default component.exports